import api from './api';
import { ConsumoVeiculo, Dashboard, RelatorioCusto } from '../types';

export const relatorioService = {
  getDashboard: async (): Promise<Dashboard> => {
    const response = await api.get<Dashboard>('/relatorios/dashboard');
    return response.data;
  },

  getConsumoVeiculo: async (veiculoId: number): Promise<ConsumoVeiculo> => {
    const response = await api.get<ConsumoVeiculo>(`/relatorios/consumo/${veiculoId}`);
    return response.data;
  },

  getRelatorioCustos: async (inicio: string, fim: string): Promise<RelatorioCusto> => {
    const response = await api.get<RelatorioCusto>('/relatorios/custos', {
      params: { inicio, fim },
    });
    return response.data;
  },

  getCustosPdf: async (inicio: string, fim: string): Promise<Blob> => {
    const response = await api.get('/relatorios/custos/pdf', {
      responseType: 'blob',
      params: { inicio, fim },
    });
    return response.data;
  },

  getVeiculosPorOrganizacaoPdf: async (): Promise<Blob> => {
    const response = await api.get('/relatorios/veiculos/por-organizacao/pdf', {
      responseType: 'blob',
    });
    return response.data;
  },

  getVeiculosPorDepartamentoPdf: async (): Promise<Blob> => {
    const response = await api.get('/relatorios/veiculos/por-departamento/pdf', {
      responseType: 'blob',
    });
    return response.data;
  },

  getAbastecimentosPdf: async (inicio?: string, fim?: string): Promise<Blob> => {
    const response = await api.get('/relatorios/abastecimentos/pdf', {
      responseType: 'blob',
      params: { inicio, fim },
    });
    return response.data;
  },

  getAbastecimentosPorDepartamentoPdf: async (inicio?: string, fim?: string, departamentoId?: number): Promise<Blob> => {
    const response = await api.get('/relatorios/abastecimentos/por-departamento/pdf', {
      responseType: 'blob',
      params: { inicio, fim, departamentoId },
    });
    return response.data;
  },

  getAbastecimentosPorSubdepartamentoPdf: async (inicio?: string, fim?: string, subdepartamentoId?: number): Promise<Blob> => {
    const response = await api.get('/relatorios/abastecimentos/por-subdepartamento/pdf', {
      responseType: 'blob',
      params: { inicio, fim, subdepartamentoId },
    });
    return response.data;
  },
};
